<template>
    <v-container grid-list-md fluid style="margin-top: -25px;">
        <v-layout row>
        <v-flex xs5>&nbsp;</v-flex>
        <v-flex xs5>
            <v-text-field label="Filter" clearable v-model="filter"></v-text-field>
        </v-flex>
        </v-layout>
        <v-list xs12 density="compact" style="height: 250px;overflow-y: scroll" id="list">
        <v-list-item
              v-for="(item, i) in filteredItems" :key="i"
              style="padding: 0; margin-top: -25px;"
            >
            <v-flex xs5 mr-1>
                <v-text-field v-model="item.name" @input="onChange"></v-text-field>
            </v-flex>
            <v-flex xs6>
                <v-textarea rows="1" v-model="item.value" @input="onChange"></v-textarea>
            </v-flex>
            <v-flex xs1>
                <v-btn text icon @click="removeItem(i)">
                    <v-icon size="small">fal fa-trash</v-icon>
                </v-btn>
            </v-flex>
        </v-list-item>
    </v-list>

        <!-- <v-layout xs12 v-for="(item, i) in items" :key="i">
            <v-flex xs5>
                <v-text-field label="Key" v-model="item.name" @input="onChange"></v-text-field>
            </v-flex>
            <v-flex xs6>
                <v-textarea rows="1" label="Value" v-model="item.value" @input="onChange"></v-textarea>
            </v-flex>
            <v-flex xs1>
                <v-btn text icon @click="removeItem(i)">
                    <v-icon size="small">fal fa-trash</v-icon>
                </v-btn>
            </v-flex>
        </v-layout> -->

        <v-layout xs12>
        <v-flex xs5>
                <v-text-field label="New Key" v-model="newItem.name"></v-text-field>
            </v-flex>
            <v-flex xs6>
                <v-textarea rows="1" label="New Value" v-model="newItem.value"></v-textarea>
            </v-flex>
            <v-flex xs1>
                <v-btn class="mt-3" text icon @click="addItem()">
                    <v-icon size="small">fal fa-check</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>

        <v-layout v-if="!hideButtons" xs12 style="justify-content: right;">
            <v-btn class="mr-4" color="primary" outlined rounded @click="cancel">Cancel</v-btn>
            <v-btn color="primary" rounded @click="save">Save</v-btn>
        </v-layout>
    </v-container>
</template>
<script>
import _ from 'lodash'
export default {
    props: {
        input: String,
        captureChanges: Boolean,
        hideButtons: Boolean
    },
    emits: ['save', 'cancel', "onChange"],
    data(){
        return {
          items: [],
          newItem: {name: '', value: ''},
          filter: ''
        }
    },
    computed: {
        filteredItems: {
            get() {
                if (_.isNil(this.filter) || _.isEmpty(this.filter)) {
                    return this.items
                }
                const filter2 = this.filter.toLowerCase()
                return _.filter(this.items, (item) => { return (!_.isNil(item.name) && (item.name.toLowerCase().indexOf(filter2) > -1)) 
                    || (!_.isNil(item.value) && (item.value.toLowerCase().indexOf(filter2) > -1)) })
            }
        }
    },
    mounted() {
        this.items = this.nvStrToList(this.input)
    },
    methods: {
        nvStrToList(str) {
            if (!str || _.isEmpty(str)) {
                return []
            }
            const tokens = _.sortBy(str.split(';'))
            const result = []
            _.forEach(tokens, (token) => {
                if (token) {
                    const subTokens = token.split('=')
                    result.push({name: subTokens[0], value: subTokens[1]})
                }
            })
            return result
        },
        listToNvStr(list) {
            if (!list || _.isEmpty(list)) {
                return ''
            }
            const result = []
            _.forEach(list, (item) => {
                result.push(item.name + '=' + item.value)
            })
            return _.join(result, ';') + ';'
        },
        removeItem(index) {
            this.items.splice(index, 1)
            if (this.captureChanges) {
                    this.$emit('onChange', this.listToNvStr(this.items))
            }
        },
        addItem() {
            if (this.newItem.name) {
                this.items.push({name: this.newItem.name, value: this.newItem.value})
                if (this.captureChanges) {
                    this.$emit('onChange', this.listToNvStr(this.items))
                }
            }
            this.newItem.name = ''
            this.newItem.value = ''
        },
        save() {
            console.log(this.items)
            this.$emit('save', this.listToNvStr(this.items))
        },
        cancel() {
            this.$emit('cancel')
        },
        onChange() {
            if (this.captureChanges) {
                this.$emit('onChange', this.listToNvStr(this.items))
            }
        }
    }
}

</script>